var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatarPrimary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    fill: "#F2F2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_131_4492)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.58 22.1747C32.58 23.5217 32.0449 24.8136 31.0924 25.7661C30.1399 26.7186 28.8481 27.2537 27.501 27.2537C26.154 27.2537 24.8621 26.7186 23.9096 25.7661C22.9571 24.8136 22.422 23.5217 22.422 22.1747C22.422 20.8277 22.9571 19.5358 23.9096 18.5833C24.8621 17.6308 26.154 17.0957 27.501 17.0957C28.8481 17.0957 30.1399 17.6308 31.0924 18.5833C32.0449 19.5358 32.58 20.8277 32.58 22.1747ZM19.1895 34.6421C19.1895 31.5945 21.6829 29.101 24.7305 29.101H30.2715C33.3191 29.101 35.8126 31.5945 35.8126 34.6421V37.4126H19.1895V34.6421Z",
    fill: "#5C4C3F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_131_4492"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.1642,
    height: 22.1642,
    fill: "white",
    transform: "translate(16.418 13.9551)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarPrimary);
export default __webpack_public_path__ + "static/media/avatar-primary.2bc7df4f2aa8e30420729dd50d738517.svg";
export { ForwardRef as ReactComponent };